import Alpine from 'alpinejs';

Alpine.data('splideCarouselWithVideo', () => ({
    playingVideoId: null,
    currentPlayerInstance: null,
    splide: null,
    featuredCarousel: false,
    perPage: 1,
    gap: '1rem',
    padding: '20%',
    slideIndex: 1,
    banner_component: false,
    autoplayInterval: 0,
    lazyLoad: 'nearby',
    init() {
        this.$nextTick(() => {
            this.initSplide();
            if (this.banner_component) {
                this.splideBannerInit();
            }
            this.splide.mount();
        });
    },
    initSplide() {
        let that = this;
        this.splide = new Splide(that.$refs.splide_carousel, {
            updateOnMove: true,
            type: 'loop',
            perPage: that.perPage,
            gap: that.gap,
            perMove: 1,
            lazyLoad: that.lazyLoad,
            preloadPages: 3,
            autoplay: that.autoplayInterval > 0,
            interval: that.autoplayInterval > 0 ? that.autoplayInterval : 3000,
            pauseOnHover: true,
            pauseOnFocus: true,
            breakpoints: {
                767: {
                    preloadPages: 3,
                    perPage: 1,
                    padding: this.padding,
                },
            },
        }).on('overflow', function (isOverflow) {
            that.splide.go(0);
            that.splide.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0, // Toggle clones
            };
        }).on('move', function (newIndex) {
            that.slideIndex = newIndex + 1;
            that.pauseVideo();
        });
    },
    // Not used by the hero/list-block carousels this component was built
    // for - the video carousel's tag pills swap the slide list's contents
    // via htmx and need the Splide instance to re-scan the new DOM after.
    refreshSplide() {
        if (this.splide) {
            this.splide.refresh();
        } else {
            this.initSplide();
            this.splide.mount();
        }
    },
    splideBannerInit() {
        let that = this;
        this.splide.on('ready', function () {
            that.calculateCaptionHeight();
        })
            .on('move', function (newIndex) {
                that.slideIndex = newIndex + 1;
                that.updateHeight()
            })
            .on('resized', function () {
                that.calculateCaptionHeight();
                that.updateHeight();
            });
    },
    nextClick() {
        this.splide.go('+${i}');
        this.pauseVideo();
    },
    prevClick() {
        this.splide.go('-${i}');
        this.pauseVideo();
    },
    calculateWidthToTranslateEntireSlider() {
        // This isn't being used anywhere but keeping it here for if/when we activate the featured sliders
        let activeSlide = this.splide.Components.Elements.slides[this.splide.index];

        // Read layout property first
        let activeSlideWidth = activeSlide.clientWidth;
        let translateAmount = (activeSlideWidth - (activeSlideWidth * .9)) / 2;

        // Then apply style change to avoid forced reflow
        requestAnimationFrame(() => {
            this.$refs.splide__track_container.style.transform = 'translateX(-' + translateAmount + 'px)';
        });
    },
    playVideoFromCarousel(videoId) {
        this.playingVideoId = videoId;
        this.$nextTick(() => {
            const gridItemElement = document.getElementById(videoId);
            const playerElement = gridItemElement.querySelector('.video-js');

            const playerId = playerElement.getAttribute('data-player');
            const embedId = playerElement.getAttribute('data-embed');

            const brightcove = window.bc[`${playerId}_${embedId}`] || window.bc;

            if (this.currentPlayerInstance) {
                this.currentPlayerInstance.dispose();
            }

            this.currentPlayerInstance = brightcove(playerElement);

            this.currentPlayerInstance.play();

            this.currentPlayerInstance.on('ended', () => {
                this.playNextVideoFromCarousel(gridItemElement);
            });
        });
    },

    playNextVideoFromCarousel(currentGridItemElement) {
        // This needs to be updated to work with the splide carousel
        const nextGridItemElement = currentGridItemElement.nextElementSibling;

        if (!nextGridItemElement) {
            const paginationContainer = document.querySelector('#video-library-pagination');

            if (!paginationContainer) {
                return;
            }

            const nextPageUrl = paginationContainer.getAttribute('data-next-page-url');

            if (!nextPageUrl) {
                return;
            }

            window.location = nextPageUrl + '#auto-play-' + window.scrollY;

            return;
        }

        const nextVideoId = nextGridItemElement.id.replace('video-gallery-item-', '');

        this.playVideoFromCarousel(nextVideoId);
    },
    pauseVideo() {
        if (this.currentPlayerInstance) {
            this.currentPlayerInstance.pause();
        }
    },
    calculateCaptionHeight() {
        let that = this;
        that.overlayHeight = 0;
        var overlays = document.querySelectorAll('.banner-caption-area');
        let pagination = document.getElementById('banner-pagination');

        // BATCH READS: First, set all heights to auto and read all heights
        for (var i = 0; i < overlays.length; i++) {
            overlays[i].style.height = 'auto';
        }

        // Read all layout properties in one batch (avoid interleaving reads/writes)
        for (var i = 0; i < overlays.length; i++) {
            if (overlays[i].offsetHeight > that.overlayHeight) {
                that.overlayHeight = overlays[i].offsetHeight;
            }
        }

        // BATCH WRITES: Then apply all style changes together
        requestAnimationFrame(function () {
            pagination.style.bottom = that.overlayHeight - 55 + 'px';
            for (var i = 0; i < overlays.length; i++) {
                overlays[i].style.height = that.overlayHeight + 'px';
            }
        });
    },
    updateHeight() {
        let that = this;
        let slide = that.splide.Components.Slides.getAt(that.splide.index).slide;
        slide.querySelector('.banner-caption-area').style.height = that.overlayHeight + 'px';
    },
}));

Alpine.data('eventVideoPlayer', () => ({
    playingVideoId: null,
    currentPlayerInstance: null,
    playVideoFromCarousel(videoId) {
        this.playingVideoId = videoId;
        this.$nextTick(() => {
            const gridItemElement = document.getElementById(videoId);
            const playerElement = gridItemElement.querySelector('.video-js');

            const playerId = playerElement.getAttribute('data-player');
            const embedId = playerElement.getAttribute('data-embed');

            const brightcove = window.bc[`${playerId}_${embedId}`] || window.bc;

            if (this.currentPlayerInstance) {
                this.currentPlayerInstance.dispose();
            }

            this.currentPlayerInstance = brightcove(playerElement);
            this.currentPlayerInstance.play();
        });
    },
}));
